
import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  // 🧠 Animation Lock: Skip entrance animation if session is already initialized
  const appLoaded = typeof window !== 'undefined' && sessionStorage.getItem('appLoaded') === 'true';

  return (
    <motion.div
      initial={appLoaded ? false : { opacity: 0, filter: 'blur(10px)' }}
      animate={{ opacity: 1, filter: 'blur(0px)' }}
      exit={appLoaded ? { opacity: 1 } : { opacity: 0, filter: 'blur(10px)' }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      className="w-full"
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
